import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import ContactCard from "../../../components/ContactCard/ContactCard";
import { getCurrentUser } from "../../../services/authService";
import styles from "./DevOps.module.css";

function DevOpsContactUs() {
  const history = useNavigate();
  React.useEffect(() => {
    localStorage.setItem(
      "selectedEventName",
      window.location.href.split("//")[1].split("/")[1]
    );

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}projects/getprojectbypath`, {
        path: window.location.href,
      })
      .then((res) => {
        if (res.data._id !== undefined) {
          axios
            .post(
              `${process.env.REACT_APP_SERVER_URL}stats/setpage/DevOpsContactUs`,
              {
                id: res.data._id,
              }
            )
            .then((res) => {});
        }
      });
  }, []);
  return (
    <div className='container-fluid p-0' style={{overflowY:"hidden"}}>
      <div className=' row'>
        <div
          className={styles["btn-back-envirtual-container"] + " col-md-12"}
          onClick={() => {
            history("/showroom/devops");
          }}
        >
          <img src='/assets/back-btn.svg' className={styles["ddl"]}></img>
          <label className={styles["back-btn-label"]}>Back</label>
        </div>
        <img
          src='/assets/showroom/mainhall/ic-bg14.png'
          className='mentor-card-screen-background p-0'
          alt=''
        />
        <div className='row'>
          <div className='col-md-3'></div>

          <div className='col-md-6 p-5 col-sm-9'>
            <iframe
              src={
                "https://vodafone.sharepoint.com/sites/WIVAFiles/_layouts/15/embed.aspx?UniqueId=5790e755-bd6a-4311-9b71-273c0a642188"
              }
              className={styles["video-background"]}
              frameborder='0'
              allowfullscreen
            ></iframe>
          </div>

          <div className='col-md-3'></div>
        </div>
      </div>
    </div>
  );
}

export default DevOpsContactUs;
